<template>
  <div class="container" :class="{inline}">
    <h4 v-if="topState">
      <div class="back" @click="back(false)" v-if="hasBack">
        <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
        <span>{{ $t('table.back') }}</span>
      </div>
      <span>{{ tableConfig.tableName }}</span>
    </h4>
    <div v-if="topState && !noSearchTerms" class="selection">
      <div style="display: flex">
        <div>
          <slot name="searchConditions"></slot>
        </div>
        <div>
          <slot name="searchTime"></slot>
        </div>
      </div>
      <div>
        <slot name="importFile"></slot>
        <slot name="searchActions"></slot>
      </div>
    </div>
    <a-table
      :row-selection="
        tableConfig.checkout ? { selectedRowKeys: tableConfig.selectedRowKeys, onChange: onSelectChange } : null
      "
      v-if="tableState"
      row-key="id"
      :locale="locale"
      :columns="tableConfig.tableColumns"
      :data-source="inline ? externalData : data"
      :scroll="{ y: tableHeight }"
      @change="handleTableChange"
    >
      <template v-for="(value, key) in $scopedSlots" :slot="key" slot-scope="text, record">
        <slot :name="key" :text="text" :record="record"></slot>
      </template>
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <a-button
            type="link"
            v-if="record.deliveryNumber !== undefined"
            style="padding-right: 0;"
            @click="seeResumeClcik(record)"
          >
            {{ $t('table.viewResume') }}
          </a-button>
          <a-button
            type="link"
            v-if="content === 'class'"
            style="padding-right: 0;"
            @click="seeResumeClcik(record)"
          >
            <span>{{ $t('table.addStudent') }}</span>
          </a-button>
          <a-button
            type="link"
            v-if="content === 'class'"
            @click="seeResumeClcik(record)"
          >
            <span>{{ $t('table.view') }}</span>
          </a-button>
          <a-button
            type="link"
            :style="{ padding: record.deliveryNumber !== undefined ? '0' : '0 0 0 0' }"
            @click="defaultEdit(record)"
          >
            {{ $t('table.edit') }}
          </a-button>
          <a-button type="link" v-if="!record.isAdmin && tableConfig.tablePort.del" style="padding-left: 0" @click="delModal(record.id)">
            {{ $t('table.delete') }}
          </a-button>
        </div>
      </template>
    </a-table>
    <div v-else-if="topState == false && tableState == false" class="nodata">
      <img :src="ImgSrc" alt="" />
      <div class="no_creat_text">{{ noCreatText }}</div>
      <div>
        <slot name="create"></slot>
      </div>
    </div>
    <div v-else-if="topState == true" class="nodata">
      <img :src="emptyImgSrc" alt="" />
      <div style="font-weight: 400;font-size: 14px;color: #333;margin-top: -30px;font-weight: 600;">{{ $t('noDataEmpty') }}</div>
      <div v-if="searchState">
        <div class="text">{{ emptyText }}</div>
      </div>
    </div>
    <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.title}</p>
        <p class='placeholder'>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.content}</p>`
      "
    />
  </div>
</template>

<script>
import { request } from '@/utils/request'
import cookie from 'js-cookie'
import debounce from 'lodash.debounce'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Emptys from '@/components/Emptys/index.vue'

export default {
  props: {
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    condition: {
      type: Object,
      default: undefined
    },
    noCreatText: {
      type: String,
      default: ''
    },
    emptyImgSrc: {
      type: String,
      default: require('@/assets/img/bj_zanwu_2.png')
    },
    ImgSrc: {
      type: String,
      default: ''
    },
    columnId: {
      type: String,
      default: ''
    },
    noSearchTerms: {
      type: Boolean,
      default: false
    },
    jobId: {
      type: Number,
      default: ''
    },
    // 勾选
    checkout: {
      type: false,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    hasBack: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    externalData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      checkoutData: null,
      passwordFlag: false,
      passwordModal: false,
      repasswordFlag: false,
      oldpasswordFlag: false,
      passwordConfirmLoading: false,
      aboutVisible: false,
      delId: undefined,
      delVisible: false,
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: this.$form.createForm(this),
      user: cookie.getJSON('user_infor'),
      userRoles: cookie.getJSON('user_type'),
      isDefaultQuery: true,
      search: debounce(this.debouncedSearch, 500),
      locale: {
        emptyText: () => {
          return this.$createElement(Emptys, {
            props: {
              inline: true,
              imgSrc: this.emptyImgSrc
            }
          })
        }
      },
      tableHeight: 0,
      topState: true,
      tableState: true,
      searchState: false
    }
  },
  computed: {
    // defaultQuery() {
    //   return !(this.pagination.total === 0 && this.isDefaultQuery)
    // },
    customSlots() {
      return this.tableConfig.tableColumns.filter(item => item.customSlots)
    }
  },
  watch: {
    searchParams: {
      deep: true,
      handler(val) {
        this.search(val)
        this.isDefaultQuery = false
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.user = cookie.getJSON('user_infor')
    })
  },
  methods: {
    // 查看简历
    seeResumeClcik(record) {
      this.$router.push({
        name: 'resume',
        query: {
          id: record.id
        }
      })
    },
    debouncedSearch(searchParams) {
      this.pagination.page = 1
      this.getList({ searchParams })
    },
    handlePaginationChange() {
      this.getList()
    },
    defaultEdit(record) {
      if (!this.tableConfig.tableEditRouteNName) {
        this.$message.error(this.$t('table.configEditRoute'))
      }
      this.$router.push({
        name: this.tableConfig.tableEditRouteNName,
        query: {
          id: record.id,
          columnId: this.columnId || undefined,
          columnTitle: this.$route.query.columnTitle || undefined
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      request({
        url: '/api' + this.tableConfig.tablePort.del,
        method: 'post',
        data: { id: this.delId }
      }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getList({})
          this.$message.success(this.$t('table.deleteSuccess'))
        }
      })
    },
    /**
     * 获取列表数据
     *
     * @param {object} params 获取列表的参数
     * @param {object} params.searchParams 搜索参数
     * @param {object} params.condition 其他条件参数
     */
    getList(searchCondition = {}) {
      const { searchParams, condition } = searchCondition
      let params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        columnId: this.columnId || undefined,
        jobId: this.jobId || undefined,
        ...(searchParams ? searchParams : this._searchParams),
        ...(condition ? condition : this._condition)
      }
      console.log('params', this._condition, condition)
      setTimeout(() => {}, 0)
      // 缓存查询条件
      this._condition = condition ? condition : this._condition
      this._searchParams = searchParams ? searchParams : this._searchParams
      // 过滤掉空值
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      )
      request({
        url: '/api' + this.tableConfig.tablePort.list,
        method: 'get',
        params: filteredParams
      }).then(res => {
        if (res.code === 200) {
          for (let i = 0; i < res.data.list.length; i++) {
            if (
              res.data.list[i].content !== undefined &&
              res.data.list[i].content !== '' &&
              res.data.list[i].content !== null
            ) {
              console.log(res.data.list[i].content)
              res.data.list[i].content = res.data.list[i].content.replace(/&lt;br&gt;/g, '<br>')
            }
          }
          this.data = getListIndex(
            nameMap(res.data.list, this.tableConfig.tablePort.list),
            this.pagination.page,
            this.pagination.pageSize
          )
          this.pagination.total = res.data.total

          let search_name = this.searchParams
          if (search_name.theme !== undefined && search_name.theme !== '') {
            search_name.name = search_name.theme
          }
          const hasSearchData = Object.values(search_name).some(value => {
            // 如果是数组，检查是否为空
            if (Array.isArray(value)) {
              return value.length > 0
            }
            // 其他情况，直接判断布尔值
            return Boolean(value)
          })
          console.log('search_name', search_name)

          console.log('hasSearchData', hasSearchData)
          console.log('res.data.total', res.data.total)
          console.log('this._condition', this._condition)
          // 初始化没有数据时
          if (!hasSearchData && res.data.total == '0' && this._condition == undefined) {
            this.topState = false
            this.tableState = false
            // 搜索没数据时
          } else if (hasSearchData && res.data.total == '0') {
            this.topState = true
            this.tableState = true
            this.locale.emptyText = () => {
              return this.$createElement(Emptys, {
                props: {
                  inline: true,
                  text: this.$t('table.noSearchResult'),
                  imgSrc: this.emptyImgSrc
                }
              })
            }
          } else {
            this.topState = true
            this.tableState = true
          }
        }
      })
    },
    handleTableChange(p, filters, sort) {
      this.isDefaultQuery = false
      this.$emit('tableChange', [filters, this.getList, sort])
    },
    onSelectChange(selectedRowKeys) {
      this.$emit('onSelectChange', selectedRowKeys)
    },
    getTableHeight() {
      const container = document.querySelector('.container')
      setTimeout(() => {
        if (container.children[0].tagName === 'H4' && container.children[0].innerText) {
          this.tableHeight = window.innerHeight - 290
        } else {
          this.tableHeight = window.innerHeight - 280
        }
      }, 500)
    },
    back() {
      this.$router.back()
    }
  },
  mounted() {
    console.log('jobId', this.jobId)
    if (this.tableConfig.tableData && this.tableConfig.tableData.length > 0) {
      this.data = this.tableConfig.tableData
      this.pagination.total = this.tableConfig.tableData.length
    } else {
      this.getList({ searchParams: this.searchParams, condition: this.condition })
    }
    this.getTableHeight()
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  padding-top: 20px;
  padding-bottom: 30px;
  /deep/ .ant-table {
    /// min-height: 583px;
    .ant-table-tbody > tr > td {
      height: 65px;
    }
  }
  position: relative;
  .list-pagination {
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
.inline {
  padding-top: 0px;
  .selection{
    margin-top: 0;
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  display: flex;
  align-items: center;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
.selection {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  .search-item {
    width: 237px;
    min-height: 35px;
  }
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    color: #000;
    margin-right: 20px;
    border-radius: 20px;
    width: 250px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
  }
}
.nodata {
  position: relative;
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  justify-content: center;
  flex-direction: column;
  height: calc(100% - 0px);
  img {
    width: 240px;
    margin-bottom: 12px;
  }
  > div {
    width: 100%;
    display: flex;
    margin-top: -9px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text {
      font-weight: 550;
      color: #0d2340;
      margin-bottom: 12px;
    }
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.search_null {
  font-weight: 400;
  font-size: 12px;
  color: #0d2340;
}
.no_creat_text {
  font-weight: 600;
  font-size: 14px;
  color: #0d2340;
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}
/deep/ .ant-table-thead > tr > th .ant-table-header-column {
  text-wrap: nowrap !important;
}
.searchActions{
  display: flex;
  justify-content: flex-end;
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  margin-right: 16px;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
</style>
